up.compiler('[clickable-row]', (element, { linkId }) => {
  const $element = $(element)
  $element.on('click', (event) => {
    if ($(event.target).closest('a, [checkable-cell]').length > 0) {
      // User clicked directly on a link or interactable table cell
      return
    }

    let $anchor = linkId ? $element.find(`a[id$="${linkId}"]`) : $element.find(`${'a'}:first`)

    if ($anchor.is('[up-layer]')) {
      up.follow($anchor, { layer: 'new' })
    } else if ($anchor.is('[up-target]')) {
      up.follow($anchor)
    } else if ($anchor.length > 0) {
      $anchor.get(0).click()
    }
  })
})
